import { type FunctionComponent } from "react";

import { sendGA4Tracking } from "scmp-app/components/tracking/google-analytics-4/apis";
import type { HeaderTab } from "scmp-app/components/tracking/google-analytics-4/types";

import { Container, EpaperLinkList } from "./styles";

type Props = {
  className?: string;
};

export const EpaperLink: FunctionComponent<Props> = ({ className }) => {
  const getTabClickHandler = (headerTab: HeaderTab) => () => {
    sendGA4Tracking({
      action: "click",
      category: "header",
      customized_parameters: {
        header: headerTab,
      },
      subcategory: "",
    });
  };

  return (
    <Container className={className}>
      <EpaperLinkList
        isAnchor
        onClick={getTabClickHandler("epaper")}
        pathname="https://scmp_epaper.pressreader.com/"
        target="_blank"
      >
        ePAPER
      </EpaperLinkList>
    </Container>
  );
};

EpaperLink.displayName = "EpaperLink";
